<template>
  <Modal
      :title="$t('auth.unauthorized')"
      @close="redirect"
  >
    {{ $t('auth.unauthorized_message') }}

    <div class="d-flex justify-content-center align-items-center mt-5">
      <a class="btn btn-primary" href="/login" @click.prevent="redirect">{{ $t('front.login') }}</a>
    </div>
  </Modal>
</template>
<script setup>
import Modal from "@/js/Components/Modal/Modal.vue";
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import {useLoader} from "@/js/Plugins/Loader.js";
const router = useRouter();
const store = useStore();
const loader = useLoader();

store.commit('auth/user', null);
store.dispatch('object/stopAllUpdates');
loader.hide();

function redirect() {
  window.location.href = '/login';
  loader.show();
}
</script>